/* __next_internal_client_entry_do_not_use__ Share auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import React from "react";
import { createSVGIcon } from "../util";
/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=4127%3A473))
 * @trackcomponent
 * @lastsynced 2023-09-21T14:42:39.547Z
 */ export var Share = createSVGIcon(/*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("path", {
            d: "M17.7499 8.71436H19.3928C19.6106 8.71436 19.8196 8.8009 19.9736 8.95495C20.1277 9.10899 20.2142 9.31793 20.2142 9.53578V21.8572C20.2142 22.0751 20.1277 22.284 19.9736 22.4381C19.8196 22.5921 19.6106 22.6786 19.3928 22.6786H4.60707C4.4992 22.6786 4.39239 22.6574 4.29273 22.6161C4.19307 22.5748 4.10251 22.5143 4.02624 22.4381C3.94996 22.3618 3.88945 22.2712 3.84817 22.1716C3.80689 22.0719 3.78564 21.9651 3.78564 21.8572V9.53578C3.78564 9.31793 3.87219 9.10899 4.02624 8.95495C4.18028 8.8009 4.38922 8.71436 4.60707 8.71436H6.24993",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M12 12.8215V1.32153",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M8.71436 4.60725L12.0001 1.32153L15.2858 4.60725",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    ]
}), "Share", {
    color: Core.icon.default,
    fill: "none",
    viewBox: "0 0 24 24"
} // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
